import React from 'react'
import { Route } from 'react-router-dom'
import PasswordReset from './PasswordReset'

import { passwordResetRoot } from "../../../constants/routePaths"

const PasswordResetRoute = [
  <Route
    key="PasswordReset"
    exact path={passwordResetRoot}
    component={PasswordReset}
  />,
];

export default PasswordResetRoute